import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
/* import sicrediStyles from 'assets/styles/default.scss'; */

export const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 0,
        marginBottom: 0,
        fontFamily: 'Nunito',
      },
      contentText: {
        paddingBottom: '40px'
      },
      toCancel: {
        textAlign: 'left'
      },
      toDelete: {
        textAlign: 'right'
      },
      buttonConfirm: {
        backgroundColor: '#e60000',
        '&:hover': {
          backgroundColor: '#d21818',
        }
      }
    }),
  {
    name: 'ConfirmDeletarPautaModal',
  }
);
